'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTracker;

var _loadSnowplowScript = require('./loadSnowplowScript');

var _loadSnowplowScript2 = _interopRequireDefault(_loadSnowplowScript);

var _setUserId = require('./setUserId');

var _setUserId2 = _interopRequireDefault(_setUserId);

var _constants = require('./constants');

var _snowplowConfigs = require('./snowplowConfigs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTracker(globalSnowplowName, userId, trackerName, trackerSettings) {
  (0, _loadSnowplowScript2.default)(globalSnowplowName);
  (0, _setUserId2.default)(globalSnowplowName, userId);

  var settings = trackerSettings;
  if (!settings) {
    settings = _snowplowConfigs.defaultConfigs.TEST;
    console.error('No tracker settings specified; Snowplow Activity Tracker falling back to default TEST configuration');
  }

  window[globalSnowplowName](_constants.NEW_TRACKER, trackerName, settings.collectorEndpoint, settings);
}
module.exports = exports['default'];